var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('input', _vm._b({
    ref: "inputRef",
    staticClass: "px-6 py-2 focus:outline-none border  w-full rounded-lg",
    attrs: {
      "type": "text"
    }
  }, 'input', _vm.$attrs, false))]);
}
var staticRenderFns = []

export { render, staticRenderFns }